import type { ReactNode } from 'react';
import { ShieldAlert } from 'lucide-react';
import type { PermissionCode } from '@asyagrup/group-hub-contracts';
import { useSession } from './session-context';

/**
 * Route-level permission gate.
 *
 * Deliberately has no "unknown means allow" branch: `permissions` is typed
 * `PermissionCode[]` with no absent state, so an unresolved session is `[]`,
 * which denies. asya.click's guard read `if (!user.permissions?.pageAccess) return true`
 * — that shape is unwritable here.
 */
export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionCode;
  children: ReactNode;
}) {
  const { can } = useSession();
  if (can(permission)) return <>{children}</>;

  return (
    <div className="mx-auto max-w-md py-16 text-center">
      <ShieldAlert className="text-fg-muted mx-auto mb-3" size={28} />
      <h1 className="text-fg text-lg font-semibold">Bu sayfaya erişim yetkiniz yok</h1>
      <p className="text-fg-muted mt-1 text-sm">Erişim gerekiyorsa sistem yöneticinizle görüşün.</p>
    </div>
  );
}
